import { TIPO_COLUNA } from '~/modules/Helper/tipoColuna';

/**
 * Retorna o label de tipo de campo para exibição no filtro (desktop e mobile).
 * Centralizado para manter os mesmos textos em ambas as versões.
 * @param {number} tipoValor - TIPO_COLUNA (ex.: TIPO_COLUNA.DATA, TIPO_COLUNA.INTEIRO)
 * @returns {string}
 */
export function obterTipoLabelFiltro(tipoValor) {
  switch (tipoValor) {
    case TIPO_COLUNA.INTEIRO:
      return 'Número (inteiro)';
    case TIPO_COLUNA.DECIMAL:
      return 'Número (decimal)';
    case TIPO_COLUNA.DATA:
      return 'Data';
    case TIPO_COLUNA.BOOLEANO:
      return 'Sim/Não';
    case TIPO_COLUNA.LINK:
      return 'Texto (link)';
    case TIPO_COLUNA.TEXTO_50:
    case TIPO_COLUNA.TEXTO_100:
      return 'Texto';
    default:
      return 'Texto';
  }
}

/**
 * Retorna a dica de preenchimento do filtro para o tooltip de ajuda.
 * @param {number} tipoValor - TIPO_COLUNA
 * @returns {string}
 */
export function obterDicaTipoFiltro(tipoValor) {
  switch (tipoValor) {
    case TIPO_COLUNA.INTEIRO:
    case TIPO_COLUNA.DECIMAL:
      return 'Dica: para números, informe o valor completo (ex.: 123).';
    case TIPO_COLUNA.DATA:
      return 'Dica: informe a data conforme o padrão esperado pelo sistema.';
    case TIPO_COLUNA.BOOLEANO:
      return 'Dica: use Sim/Não (ou True/False) conforme o valor exibido.';
    default:
      return 'Dica: em texto, a busca pode encontrar valores parciais (ex.: "1" encontra "123").';
  }
}
